import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    HStack,
    VStack,
    useToast,
    Spinner,
} from '@chakra-ui/react';
import { PlayerSegment } from '@repo/alictus-common/types/segment';

export function ToggleSegmentEnvironmentModal({
    segmentInstance,
    disclosure,
    onConfirm,
    isLoading,
}: {
    segmentInstance: PlayerSegment;
    disclosure: { isOpen: boolean; onClose: () => void };
    onConfirm: () => void;
    isLoading: boolean;
}) {
    return (
        <Modal isOpen={disclosure.isOpen} onClose={disclosure.onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    {segmentInstance.isTest ? 'Move to Production?' : 'Move to Development?'}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack>
                        <div>
                            Are you sure you want to move <b>{segmentInstance.name}</b> to{' '}
                            <b>{segmentInstance.isTest ? 'Production' : 'Development'}</b>?
                        </div>
                        <HStack>
                            <Button variant="outline" mr={3} onClick={disclosure.onClose}>
                                Cancel
                            </Button>
                            {isLoading ? (
                                <Spinner />
                            ) : (
                                <Button
                                    colorScheme="blue"
                                    mr={3}
                                    onClick={onConfirm}
                                >
                                    Confirm
                                </Button>
                            )}
                        </HStack>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export default ToggleSegmentEnvironmentModal;